import { render } from "./thisOrThatTwo.vue?vue&type=template&id=fda7683c"
import script from "./thisOrThatTwo.vue?vue&type=script&lang=js"
export * from "./thisOrThatTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__